import { Box, styled } from '@mui/material';

export const CompleteNodeTextBox = styled(Box)({
    borderRadius: '12px',
    padding: '16px',
    height: '100%',
    background:
        'linear-gradient(171deg, rgba(58, 98, 227, 0.18) 0%, rgba(89, 184, 202, 0.18) 100%)',
    boxShadow: '9px 8px 41px 0px rgba(0, 0, 0, 0.59)',
    position: 'relative',
    display: 'flex',
});
